export const MustValueProps = [
  {fieldName: 'wxProps.nickname', propName: '微信昵称'},
  {fieldName: 'memberInfo.score', propName: '积分'},
  {fieldName: 'memberInfo.scoreSum', propName: '累计总积分'},
  {fieldName: 'wxProps.subscribeTime', propName: '关注时间'},
];

export const ExcludeProps = [
  {fieldName: 'traceInfo.total', propName: '轨迹'},
  {fieldName: 'wxProps.openid', propName: 'OpenID'},
  {fieldName: 'groups', propName: '组'},
  {fieldName: 'latelyInteractiveTime', propName: '上次互动时间'},
  {fieldName: 'wxProps.sex', propName: '性别'},
  {fieldName: 'hobby', propName: '兴趣爱好'},
  {fieldName: 'maritalStatus', propName: '婚姻状况'},
  {fieldName: 'income', propName: '月收入'},
];
